export enum EStoreIdentifier {
  AUTH_STORE = 'auth_store',
  ORDER_STORE = 'order_store',
  MODAL_STORE = 'modal_store',
  NOTIFICATION_STORE = 'notification_store',
  KITCHEN_TAB_STORE = 'kitchen_tab_store',
}
export enum ELocalStorageKey {
  JWT_TOKEN = 'kitchen_auth_jwt',
  NOTIFICATION_SETTINGS = 'kitchen_notification_settings',
}
export enum ENotificationSubject {
  ORDER_REJECTED = 'order_rejected',
  ORDER_ACCEPTED = 'order_accepted',
  ORDER_READY = 'order_ready',
  ORDER_CREATED = 'order_created',
  ORDER_UPDATE = 'order_updated',
  ORDER_ABORDED = 'order_aborded',
  ORDER_DELAY = 'order_delay',
}
export enum ENotificationStatus {
  READ = 'read',
  UNREAD = 'unread',
}
